import axios from 'axios'
import { useAuthStore } from '@/stores/auth'
import router from '@/router'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000/api/'

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 30000
})

api.interceptors.request.use(
  (config) => {
    const authStore = useAuthStore()
    if (authStore.token && authStore.token !== 'unauth') {
      config.headers.Authorization = `${authStore.token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    const { response } = error
    
    if (response) {
      switch (response.status) {
        case 401:
        case 502:
          const authStore = useAuthStore()
          authStore.logout()
          router.push('/login')
          break
        case 500:
        case 501:
        case 400:
        case 403:
        case 422:
        case 404:
          const message = response.data?.message || 'Terjadi kesalahan'
          console.error('API Error:', message)
          break
      }
    }
    
    return Promise.reject(error)
  }
)

export default api

export const authApi = {
  login: (credentials) => api.post('/auth/login', credentials),
  getProfile: () => api.get('/employee/me'),
  changePassword: ({ oldPassword, newPassword, confirmPassword }) => api.post('/employee/update-password', {
    old_password: oldPassword,
    new_password: newPassword,
    confirm_password: confirmPassword
  }),
  changeProfile: (data) => api.post('/employee/change-photo', data)
}

export const attendanceApi = {
  getServerTime: () => api.get('/attendance/time'),
  getToday: () => api.get('/attendance/get'),
  getReport: () => api.get('/attendance/report'),
  getHistory: (params) => api.get('/attendance/history', { params }),
  checkIn: (data) => api.post('/attendance/checkin', data),
  checkOut: (data) => api.post('/attendance/checkout', data)
}

export const mediaApi = {
  upload: (formData) => api.post('/media/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}

export const leaveApi = {
  getTypes: () => api.get('/leave/types'),
  getHistory: (params) => api.get('/leave/history', { params }),
  request: (data) => api.post('/leave/request', data)
}
